import { jsx as _jsx } from "react/jsx-runtime";
var Linkedin = function Linkedin(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.99991 5.25C2.99991 4.008 4.00791 3 5.24991 3C6.49191 3 7.49991 4.008 7.49991 5.25C7.49991 6.492 6.49191 7.5 5.24991 7.5C4.00791 7.5 2.99991 6.492 2.99991 5.25ZM15.1503 8.4004C11.9193 8.4004 9.29931 11.0044 9.29931 14.2144V20.0994C9.29931 20.5964 9.70331 21.0004 10.2003 21.0004H12.2993C12.7963 21.0004 13.2003 20.5964 13.2003 20.0994V14.2144C13.2003 13.0784 14.1843 12.1704 15.3523 12.2874C16.3663 12.3884 17.0993 13.3154 17.0993 14.3344V20.0994C17.0993 20.5964 17.5033 21.0004 18.0003 21.0004H20.0993C20.5963 21.0004 21.0003 20.5964 21.0003 20.0994V14.2144C21.0003 11.0044 18.3803 8.4004 15.1503 8.4004ZM6.59951 9.2998H3.90051C3.40351 9.2998 2.99951 9.7028 2.99951 10.1998V20.0998C2.99951 20.5968 3.40351 20.9998 3.90051 20.9998H6.59951C7.09651 20.9998 7.49951 20.5968 7.49951 20.0998V10.1998C7.49951 9.7028 7.09651 9.2998 6.59951 9.2998Z",
      fill: color
    })
  });
};
export default Linkedin;